module.exports = __webpack_public_path__ + "static/offices-content-image-3-757c68d8bfa30e787c9a345835dc1624.jpg";